unit UFrameAssociacaoProdutos;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, UUtils, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Lists, WEBLib.Grids, WEBLib.DBCtrls, Grid.Plugins,
  UHelperServer, WEBLib.WebCtrls, XData.Web.Client, System.StrUtils,
  UConstantes, UWeb.Enum;

type
  TFrameAssociacaoProdutos = class(TFrame)
    lblCodigoProdutoAssociado: TLabel;
    lblNomeProdutoAssociado: TLabel;
    lblCodBarrasProdutoAssociado: TLabel;
    lblStatusProdutoAssociado: TLabel;
    imgProduto: TImageControl;
    pnlProdutoAssociado: TPanel;
    edtCodigoProdutoAssociado: TEdit;
    edtNomeProdutoAssociado: TEdit;
    edtCodBarrasProdutoAssociado: TEdit;
    edtStatusProdutoAssociado: TEdit;
    btnAssociarProduto: TButton;
    btnAlterarImagem: TButton;
    btnRemoverAssociacao: TButton;
    btnSolicitarCadastroProduto: TButton;
    lblProdutosPaginacao: TLabel;
    pnlModalBuscarProdutos: TPanel;
    tblProdutos: TDBTableControl;
    cbbProdutos: TComboBox;
    edtProdutos: TEdit;
    wlcProdutoPaginacao: TListControl;
    cdsProdutos: TXDataWebDataSet;
    cdsProdutosid: TIntegerField;
    cdsProdutosnome: TStringField;
    cdsProdutoscodigo_barras: TStringField;
    cdsProdutosimagem: TStringField;
    dtsProdutos: TDataSource;
    imgImagemSelecionada: TImageControl;
    pnlModalAlterarImagem: TPanel;
    wfpImagem: TFilePicker;
    btnSalvarImagem: TButton;
    divRemoverImagem: THTMLDiv;
    XDataWebClientAssociacao: TXDataWebClient;
    btnPesquisarFsProduto: TButton;
    procedure btnAssociarProdutoClick(Sender: TObject);
    [Async]
    procedure btnRemoverAssociacaoClick(Sender: TObject); async;
    procedure XDataWebClientAssociacaoError(Error: TXDataClientError);
    [Async]
    procedure btnSalvarImagemClick(Sender: TObject); async;
    [Async]
    procedure btnSolicitarCadastroProdutoClick(Sender: TObject); async;
    procedure btnAlterarImagemClick(Sender: TObject);
    procedure divRemoverImagemClick(Sender: TObject);
    procedure wfpImagemChange(Sender: TObject);
    procedure wfpImagemGetFileAsBase64(Sender: TObject; AFileIndex: Integer;
      ABase64: string);
    procedure tblProdutosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblProdutosGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbbProdutosChange(Sender: TObject);
    procedure edtProdutosKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure btnPesquisarFsProdutoClick(Sender: TObject);
    procedure cdsProdutosidGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
  private
    FGridPluginProdutos : TGridPlugin;
    FProdutoId,
    FProdutoNome,
    FProdutoCodigoBarras : string;

    procedure LimparImagemSelecionada;
    function GetStatusAssociacao(pStatus : string) : string;
    procedure ValidarBotoesAssociacao(pStatus : string);
    procedure ConfigurarPermissao;
  public
    procedure SetDadosProdutoAliado(pId, pNome, pCodigoBarras, pCodigoInterno : string);
    procedure SetDadosProdutoAssociado(pStatus, pId, pNome, pCodigoBarras,
      pImagem, pImagemAprovacao : string);
  protected procedure LoadDFMValues; override; end;

var
  FrameAssociacaoProdutos: TFrameAssociacaoProdutos;

implementation

uses
  ConnectionModule;

{$R *.dfm}

procedure TFrameAssociacaoProdutos.btnAlterarImagemClick(Sender: TObject);
begin
  TUtils.OcultarElemento('divImagemSelecionada');
  LimparImagemSelecionada;
  TUtils.OpenModal('modal_alterar_imagem');
end;

procedure TFrameAssociacaoProdutos.btnAssociarProdutoClick(Sender: TObject);
begin
  if not Assigned(FGridPluginProdutos) then
  begin
    FGridPluginProdutos := TGridPlugin.Create(tblProdutos, cdsProdutos, wlcProdutoPaginacao, lblProdutosPaginacao);
    FGridPluginProdutos.FDatasetPlugin.FOrderByPadrao := 'nome asc';
  end;

  FGridPluginProdutos.SetPageSize(StrToInt(cbbProdutos.Text));
  FGridPluginProdutos.SetFilterText(EmptyStr);
  FGridPluginProdutos.Load;

  TUtils.OpenModal('modal_produtos');
end;

procedure TFrameAssociacaoProdutos.btnPesquisarFsProdutoClick(Sender: TObject);
begin
  FGridPluginProdutos.FDatasetPlugin.FParametroPersonalizado := 'fulltext=' + edtProdutos.Text;
  FGridPluginProdutos.Load;
end;

procedure TFrameAssociacaoProdutos.btnRemoverAssociacaoClick(Sender: TObject);
var
  lJson : TJSObject;
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja ' +
    'desassociar o produto <b>' + edtNomeProdutoAssociado.Text + '</b> do produto <b>' + FProdutoNome + '</b>?')) then
  begin
    lJson := TJSObject.New;
    lJson['codigo_produto'] := FProdutoId;
    lJson['status'] := 0;

    TUtils.ChamarDivLoading;
    XDataWebClientAssociacao.RawInvoke('IService.ConfigurarAssociacaoProdutos', [lJson], 'null');
  end;
end;

procedure TFrameAssociacaoProdutos.btnSalvarImagemClick(Sender: TObject);
var
  lImagemBase64 : string;
  lJson : TJSObject;
begin
  lImagemBase64 := imgImagemSelecionada.URL;

  if lImagemBase64 = '' then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhuma imagem foi adicionada!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'A imagem informada será ' +
    'enviada para aprovação, caso aprovada a associação será automática!' + sLineBreak + 'Deseja continuar?')) then
  begin
    lJson := TJSObject.New;
    lJson['codigo_produto'] := FProdutoId;
    lJson['status'] := 2;
    lJson['imagem_base64'] := lImagemBase64;

    TUtils.ChamarDivLoading;
    XDataWebClientAssociacao.RawInvoke('IService.ConfigurarAssociacaoProdutos', [lJson], 'modal_alterar_imagem');
  end;
end;

procedure TFrameAssociacaoProdutos.btnSolicitarCadastroProdutoClick(
  Sender: TObject);
var
  lJson : TJSObject;
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'O cadastro do produto ' +
    '<b>'+FProdutoNome+'</b> será enviado para aprovação, caso aprovado a associação será automática!' +
      sLineBreak + 'Deseja continuar?')) then
  begin
    lJson := TJSObject.New;
    lJson['codigo_produto'] := FProdutoId;
    lJson['status'] := 3;
    lJson['codigo_barras'] := FProdutoCodigoBarras;

    TUtils.ChamarDivLoading;
    XDataWebClientAssociacao.RawInvoke('IService.ConfigurarAssociacaoProdutos', [lJson], 'modal_produtos');
  end;
end;

procedure TFrameAssociacaoProdutos.cbbProdutosChange(Sender: TObject);
begin
  FGridPluginProdutos.SetPageSize(StrToInt(cbbProdutos.Text), True);
end;

procedure TFrameAssociacaoProdutos.cdsProdutosidGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarNumeroInteiro(Sender.AsInteger);
end;

procedure TFrameAssociacaoProdutos.ConfigurarPermissao;
begin
  if not TUtils.PossuiPermissao('fs_prod_produtos', TTipoPermissao.VISUALIZAR) then
    btnAssociarProduto.Enabled := False;

  if not TUtils.PossuiPermissao('produtos', TTipoPermissao.ALTERAR) then
  begin
    btnAlterarImagem.Enabled := False;
    btnRemoverAssociacao.Enabled := False;
    btnSolicitarCadastroProduto.Enabled := False;
  end;
end;

procedure TFrameAssociacaoProdutos.divRemoverImagemClick(Sender: TObject);
begin
  TUtils.OcultarElemento('divImagemSelecionada');
  LimparImagemSelecionada;
end;

procedure TFrameAssociacaoProdutos.edtProdutosKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  if Key = 13 then
  begin
    FGridPluginProdutos.FDatasetPlugin.FParametroPersonalizado := 'fulltext=' + edtProdutos.Text;
    FGridPluginProdutos.Load;
  end;
end;

function TFrameAssociacaoProdutos.GetStatusAssociacao(pStatus: string): string;
begin
  Result := 'SEM PRODUTO ASSOCIADO';

  if (pStatus = '') or (pStatus.ToUpper = 'NULL') then
    Exit;

  case StrToInt(pStatus) of
    1: Result := 'ASSOCIADO';
    2: Result := 'AGUARDANDO VALIDAÇÃO FOTO';
    3: Result := 'AGUARDANDO VALIDAÇÃO CADASTRO';
  end;
end;

procedure TFrameAssociacaoProdutos.LimparImagemSelecionada;
begin
  imgImagemSelecionada.URL := '';
  wfpImagem.Files.Clear;
end;

procedure TFrameAssociacaoProdutos.SetDadosProdutoAliado(pId, pNome, pCodigoBarras, pCodigoInterno: string);
begin
  FProdutoId := pId;
  FProdutoNome := pNome;
  FProdutoCodigoBarras := pCodigoBarras;

  asm
    $('#edtCodigoProdutoAssociadoModal').val(pCodigoInterno);
    $('#edtNomeProdutoAssociadoModal').val(pNome);
    $('#edtCodBarrasProdutoAssociadoModal').val(pCodigoBarras);
  end;
end;

procedure TFrameAssociacaoProdutos.SetDadosProdutoAssociado(pStatus, pId,
  pNome, pCodigoBarras, pImagem, pImagemAprovacao: string);
var
  lStatus,
  lCodigo,
  lNome,
  lCodigoBarras,
  lImagem : string;
begin
  lStatus := GetStatusAssociacao(pStatus).ToUpper;
  edtStatusProdutoAssociado.Text := lStatus;

  case IndexStr(lStatus, ['SEM PRODUTO ASSOCIADO', 'ASSOCIADO', 'AGUARDANDO VALIDAÇÃO FOTO',
    'AGUARDANDO VALIDAÇÃO CADASTRO']) of
    0:
    begin
      lCodigo := '';
      lNome := '';
      lCodigoBarras := '';
      lImagem := '';
    end;
    1, 2:
    begin
      lCodigo := pId;
      lNome := pNome;
      lCodigoBarras := pCodigoBarras;

      if lStatus = 'ASSOCIADO' then
        lImagem := pImagem
      else
        lImagem := pImagemAprovacao;
    end;
    3:
    begin
      lCodigo := '';
      lNome := FProdutoNome;
      lCodigoBarras := FProdutoCodigoBarras;
      lImagem := pImagemAprovacao;
    end;
  end;

  if (lImagem = '') or (lImagem.ToUpper = 'NULL') then
    imgProduto.url := 'assets/img/produto_sem_imagem.webp'
  else
    imgProduto.url := lImagem;

  edtCodigoProdutoAssociado.Text := lCodigo;
  edtNomeProdutoAssociado.Text := lNome;
  edtCodBarrasProdutoAssociado.Text := lCodigoBarras;

  ValidarBotoesAssociacao(lStatus);
end;

procedure TFrameAssociacaoProdutos.tblProdutosGetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordBase64,
  RecordProdutoNome : string;
  lJson : TJSObject;
  RecordProdutoId : Integer;

  [Async]
  procedure AssociarButtonClick(Sender: TObject); async;
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja ' +
      'associar o produto <b>' + RecordProdutoNome + '</b> ao produto <b>' + FProdutoNome + '</b>?')) then
    begin
      lJson := TJSObject.New;
      lJson['codigo_produto'] := FProdutoId;
      lJson['status'] := 1;
      lJson['codigo_fs_produto'] := RecordProdutoId;

      TUtils.ChamarDivLoading;
      XDataWebClientAssociacao.RawInvoke('IService.ConfigurarAssociacaoProdutos', [lJson], 'modal_produtos');
    end;
  end;

var
  Button: TButton;
  lImagem : TImageControl;
begin
  if ARow = 0 then
    Exit;

  if tblProdutos.Columns[ACol].Title = 'Associar' then
  begin
    RecordProdutoNome := cdsProdutos.FieldByName('nome').AsString;
    RecordProdutoId := cdsProdutos.FieldByName('id').AsInteger;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-boxes"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_associar_produto_modal');

    if not TUtils.PossuiPermissao('produtos', TTipoPermissao.ALTERAR) or
      (edtCodBarrasProdutoAssociado.Text = cdsProdutos.FieldByName('codigo_barras').AsString) then
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end
    else
    begin
      Button.OnClick := @AssociarButtonClick;
      Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Associar produto');
    end;
  end
  else if tblProdutos.Columns[ACol].Title = 'Imagem' then
  begin
    RecordBase64 := cdsProdutos.FieldByName('imagem').AsString;

    lImagem := TImageControl.Create(nil);
    lImagem.ParentElement := AElement.element;
    lImagem.Width := 50;
    lImagem.Height := 50;
    lImagem.AutoSize := False;

    if (RecordBase64 = '') or (RecordBase64.ToUpper = 'NULL') then
      lImagem.url := 'assets/img/produto_sem_imagem.webp'
    else
      lImagem.url := RecordBase64;
  end;
end;

procedure TFrameAssociacaoProdutos.tblProdutosGetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblProdutos.Columns[ACol].DataField, ['nome', 'codigo_barras', 'id']) of
      0: AClassName := 'text-left';
      1, 2: AClassName := 'text-end';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFrameAssociacaoProdutos.ValidarBotoesAssociacao(pStatus: string);
begin
  btnAssociarProduto.Enabled := True;
  btnAlterarImagem.Enabled := True;
  btnRemoverAssociacao.Enabled := True;
  btnAssociarProduto.Visible := False;
  btnAlterarImagem.Visible := False;
  btnRemoverAssociacao.Visible := False;

  case IndexStr(pStatus, ['SEM PRODUTO ASSOCIADO', 'ASSOCIADO', 'AGUARDANDO VALIDAÇÃO FOTO',
    'AGUARDANDO VALIDAÇÃO CADASTRO']) of
    0: btnAssociarProduto.Visible := True;
    1:
    begin
      btnAssociarProduto.Visible := True;
      btnAlterarImagem.Visible := True;
      btnRemoverAssociacao.Visible := True;
    end;
    2: btnRemoverAssociacao.Visible := True;
    3:
    begin
      btnRemoverAssociacao.Visible := True;
      btnAlterarImagem.Visible := True;
    end;
  end;

  ConfigurarPermissao;
end;

procedure TFrameAssociacaoProdutos.wfpImagemChange(Sender: TObject);
begin
  if wfpImagem.Files.Count > 0 then
  begin
    if not THelperServer.ValidarExtensaoImagemProduto(wfpImagem.Files[0].Name) then
    begin
      TUtils.OcultarElemento('divImagemSelecionada');

      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Formato de imagem inválido!' +
        sLineBreak + 'Formatos válidos: <b>png | jpg | jpeg | webp');

      LimparImagemSelecionada;
    end
    else if not THelperServer.ValidarTamanhoImagemProduto(wfpImagem.Files[0].Size) then
    begin
      TUtils.OcultarElemento('divImagemSelecionada');

      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Tamanho de imagem inválido!' +
        sLineBreak + 'Insira uma imagem de até 1MB.');

      LimparImagemSelecionada;
    end
    else
      wfpImagem.Files[0].GetFileAsBase64;
  end;
end;

procedure TFrameAssociacaoProdutos.wfpImagemGetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  imgImagemSelecionada.URL := 'data:image/'+TUtils.GetExtensaoArquivo(wfpImagem.Files[0].Name)+';base64,' + ABase64;
  TUtils.MostrarElemento('divImagemSelecionada');
end;

procedure TFrameAssociacaoProdutos.XDataWebClientAssociacaoError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFrameAssociacaoProdutos.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblCodigoProdutoAssociado := TLabel.Create('lblCodigoProdutoAssociado');
  lblNomeProdutoAssociado := TLabel.Create('lblNomeProdutoAssociado');
  lblCodBarrasProdutoAssociado := TLabel.Create('lblCodBarrasProdutoAssociado');
  lblStatusProdutoAssociado := TLabel.Create('lblStatusProdutoAssociado');
  imgProduto := TImageControl.Create('imgProduto');
  lblProdutosPaginacao := TLabel.Create('lblProdutosPaginacao');
  imgImagemSelecionada := TImageControl.Create('imgImagemSelecionada');
  pnlProdutoAssociado := TPanel.Create(Self);
  edtCodigoProdutoAssociado := TEdit.Create('edtCodigoProdutoAssociado');
  edtNomeProdutoAssociado := TEdit.Create('edtNomeProdutoAssociado');
  edtCodBarrasProdutoAssociado := TEdit.Create('edtCodBarrasProdutoAssociado');
  edtStatusProdutoAssociado := TEdit.Create('edtStatusProdutoAssociado');
  btnAssociarProduto := TButton.Create('btnAssociarProduto');
  btnAlterarImagem := TButton.Create('btnAlterarImagem');
  btnRemoverAssociacao := TButton.Create('btnRemoverAssociacao');
  btnSolicitarCadastroProduto := TButton.Create('btnSolicitarCadastroProduto');
  pnlModalBuscarProdutos := TPanel.Create(Self);
  tblProdutos := TDBTableControl.Create('tblProdutos');
  cbbProdutos := TComboBox.Create('cbbProdutos');
  edtProdutos := TEdit.Create('edtProdutos');
  wlcProdutoPaginacao := TListControl.Create('wlcProdutoPaginacao');
  pnlModalAlterarImagem := TPanel.Create(Self);
  wfpImagem := TFilePicker.Create('wfpImagem');
  btnSalvarImagem := TButton.Create('btnSalvarImagem');
  divRemoverImagem := THTMLDiv.Create('divRemoverImagem');
  btnPesquisarFsProduto := TButton.Create('btnPesquisarFsProduto');
  cdsProdutos := TXDataWebDataSet.Create(Self);
  cdsProdutosid := TIntegerField.Create(Self);
  cdsProdutosnome := TStringField.Create(Self);
  cdsProdutoscodigo_barras := TStringField.Create(Self);
  cdsProdutosimagem := TStringField.Create(Self);
  dtsProdutos := TDataSource.Create(Self);
  XDataWebClientAssociacao := TXDataWebClient.Create(Self);

  lblCodigoProdutoAssociado.BeforeLoadDFMValues;
  lblNomeProdutoAssociado.BeforeLoadDFMValues;
  lblCodBarrasProdutoAssociado.BeforeLoadDFMValues;
  lblStatusProdutoAssociado.BeforeLoadDFMValues;
  imgProduto.BeforeLoadDFMValues;
  lblProdutosPaginacao.BeforeLoadDFMValues;
  imgImagemSelecionada.BeforeLoadDFMValues;
  pnlProdutoAssociado.BeforeLoadDFMValues;
  edtCodigoProdutoAssociado.BeforeLoadDFMValues;
  edtNomeProdutoAssociado.BeforeLoadDFMValues;
  edtCodBarrasProdutoAssociado.BeforeLoadDFMValues;
  edtStatusProdutoAssociado.BeforeLoadDFMValues;
  btnAssociarProduto.BeforeLoadDFMValues;
  btnAlterarImagem.BeforeLoadDFMValues;
  btnRemoverAssociacao.BeforeLoadDFMValues;
  btnSolicitarCadastroProduto.BeforeLoadDFMValues;
  pnlModalBuscarProdutos.BeforeLoadDFMValues;
  tblProdutos.BeforeLoadDFMValues;
  cbbProdutos.BeforeLoadDFMValues;
  edtProdutos.BeforeLoadDFMValues;
  wlcProdutoPaginacao.BeforeLoadDFMValues;
  pnlModalAlterarImagem.BeforeLoadDFMValues;
  wfpImagem.BeforeLoadDFMValues;
  btnSalvarImagem.BeforeLoadDFMValues;
  divRemoverImagem.BeforeLoadDFMValues;
  btnPesquisarFsProduto.BeforeLoadDFMValues;
  cdsProdutos.BeforeLoadDFMValues;
  cdsProdutosid.BeforeLoadDFMValues;
  cdsProdutosnome.BeforeLoadDFMValues;
  cdsProdutoscodigo_barras.BeforeLoadDFMValues;
  cdsProdutosimagem.BeforeLoadDFMValues;
  dtsProdutos.BeforeLoadDFMValues;
  XDataWebClientAssociacao.BeforeLoadDFMValues;
  try
    Name := 'FrameAssociacaoProdutos';
    Left := 0;
    Top := 0;
    Width := 914;
    Height := 228;
    TabOrder := 0;
    lblCodigoProdutoAssociado.SetParentComponent(Self);
    lblCodigoProdutoAssociado.Name := 'lblCodigoProdutoAssociado';
    lblCodigoProdutoAssociado.Left := 3;
    lblCodigoProdutoAssociado.Top := 30;
    lblCodigoProdutoAssociado.Width := 25;
    lblCodigoProdutoAssociado.Height := 15;
    lblCodigoProdutoAssociado.Caption := 'C'#243'd:';
    lblCodigoProdutoAssociado.Color := clBtnFace;
    lblCodigoProdutoAssociado.HeightPercent := 100.000000000000000000;
    lblCodigoProdutoAssociado.WidthPercent := 100.000000000000000000;
    lblNomeProdutoAssociado.SetParentComponent(Self);
    lblNomeProdutoAssociado.Name := 'lblNomeProdutoAssociado';
    lblNomeProdutoAssociado.Left := 3;
    lblNomeProdutoAssociado.Top := 60;
    lblNomeProdutoAssociado.Width := 36;
    lblNomeProdutoAssociado.Height := 15;
    lblNomeProdutoAssociado.Caption := 'Nome:';
    lblNomeProdutoAssociado.Color := clBtnFace;
    lblNomeProdutoAssociado.HeightPercent := 100.000000000000000000;
    lblNomeProdutoAssociado.WidthPercent := 100.000000000000000000;
    lblCodBarrasProdutoAssociado.SetParentComponent(Self);
    lblCodBarrasProdutoAssociado.Name := 'lblCodBarrasProdutoAssociado';
    lblCodBarrasProdutoAssociado.Left := 3;
    lblCodBarrasProdutoAssociado.Top := 86;
    lblCodBarrasProdutoAssociado.Width := 63;
    lblCodBarrasProdutoAssociado.Height := 15;
    lblCodBarrasProdutoAssociado.Caption := 'C'#243'd. Barras:';
    lblCodBarrasProdutoAssociado.Color := clBtnFace;
    lblCodBarrasProdutoAssociado.HeightPercent := 100.000000000000000000;
    lblCodBarrasProdutoAssociado.WidthPercent := 100.000000000000000000;
    lblStatusProdutoAssociado.SetParentComponent(Self);
    lblStatusProdutoAssociado.Name := 'lblStatusProdutoAssociado';
    lblStatusProdutoAssociado.Left := 3;
    lblStatusProdutoAssociado.Top := 114;
    lblStatusProdutoAssociado.Width := 35;
    lblStatusProdutoAssociado.Height := 15;
    lblStatusProdutoAssociado.Caption := 'Status:';
    lblStatusProdutoAssociado.Color := clBtnFace;
    lblStatusProdutoAssociado.HeightPercent := 100.000000000000000000;
    lblStatusProdutoAssociado.WidthPercent := 100.000000000000000000;
    imgProduto.SetParentComponent(Self);
    imgProduto.Name := 'imgProduto';
    imgProduto.Left := 3;
    imgProduto.Top := 135;
    imgProduto.Width := 100;
    imgProduto.Height := 26;
    imgProduto.HeightPercent := 100.000000000000000000;
    imgProduto.WidthPercent := 100.000000000000000000;
    imgProduto.ChildOrder := 91;
    lblProdutosPaginacao.SetParentComponent(Self);
    lblProdutosPaginacao.Name := 'lblProdutosPaginacao';
    lblProdutosPaginacao.Left := 808;
    lblProdutosPaginacao.Top := 167;
    lblProdutosPaginacao.Width := 151;
    lblProdutosPaginacao.Height := 15;
    lblProdutosPaginacao.Caption := 'Showing 1 to 10 of 57 entries';
    lblProdutosPaginacao.Color := clBtnFace;
    lblProdutosPaginacao.HeightPercent := 100.000000000000000000;
    lblProdutosPaginacao.WidthPercent := 100.000000000000000000;
    imgImagemSelecionada.SetParentComponent(Self);
    imgImagemSelecionada.Name := 'imgImagemSelecionada';
    imgImagemSelecionada.Left := 369;
    imgImagemSelecionada.Top := 26;
    imgImagemSelecionada.Width := 100;
    imgImagemSelecionada.Height := 41;
    imgImagemSelecionada.HeightPercent := 100.000000000000000000;
    imgImagemSelecionada.WidthPercent := 100.000000000000000000;
    imgImagemSelecionada.ChildOrder := 91;
    pnlProdutoAssociado.SetParentComponent(Self);
    pnlProdutoAssociado.Name := 'pnlProdutoAssociado';
    pnlProdutoAssociado.Left := 3;
    pnlProdutoAssociado.Top := 3;
    pnlProdutoAssociado.Width := 360;
    pnlProdutoAssociado.Height := 17;
    pnlProdutoAssociado.Caption := 'Espa'#231'o form associa'#231#227'o';
    pnlProdutoAssociado.ChildOrder := 23;
    pnlProdutoAssociado.Color := clInfoText;
    pnlProdutoAssociado.Font.Charset := DEFAULT_CHARSET;
    pnlProdutoAssociado.Font.Color := clWhite;
    pnlProdutoAssociado.Font.Height := -11;
    pnlProdutoAssociado.Font.Name := 'Tahoma';
    pnlProdutoAssociado.Font.Style := [fsBold];
    pnlProdutoAssociado.ParentFont := False;
    pnlProdutoAssociado.TabOrder := 0;
    pnlProdutoAssociado.Visible := False;
    edtCodigoProdutoAssociado.SetParentComponent(Self);
    edtCodigoProdutoAssociado.Name := 'edtCodigoProdutoAssociado';
    edtCodigoProdutoAssociado.Left := 112;
    edtCodigoProdutoAssociado.Top := 30;
    edtCodigoProdutoAssociado.Width := 121;
    edtCodigoProdutoAssociado.Height := 22;
    edtCodigoProdutoAssociado.ChildOrder := 89;
    edtCodigoProdutoAssociado.Enabled := False;
    edtCodigoProdutoAssociado.HeightPercent := 100.000000000000000000;
    edtCodigoProdutoAssociado.WidthPercent := 100.000000000000000000;
    edtNomeProdutoAssociado.SetParentComponent(Self);
    edtNomeProdutoAssociado.Name := 'edtNomeProdutoAssociado';
    edtNomeProdutoAssociado.Left := 112;
    edtNomeProdutoAssociado.Top := 57;
    edtNomeProdutoAssociado.Width := 121;
    edtNomeProdutoAssociado.Height := 22;
    edtNomeProdutoAssociado.ChildOrder := 89;
    edtNomeProdutoAssociado.Enabled := False;
    edtNomeProdutoAssociado.HeightPercent := 100.000000000000000000;
    edtNomeProdutoAssociado.WidthPercent := 100.000000000000000000;
    edtCodBarrasProdutoAssociado.SetParentComponent(Self);
    edtCodBarrasProdutoAssociado.Name := 'edtCodBarrasProdutoAssociado';
    edtCodBarrasProdutoAssociado.Left := 112;
    edtCodBarrasProdutoAssociado.Top := 83;
    edtCodBarrasProdutoAssociado.Width := 121;
    edtCodBarrasProdutoAssociado.Height := 22;
    edtCodBarrasProdutoAssociado.ChildOrder := 89;
    edtCodBarrasProdutoAssociado.Enabled := False;
    edtCodBarrasProdutoAssociado.HeightPercent := 100.000000000000000000;
    edtCodBarrasProdutoAssociado.WidthPercent := 100.000000000000000000;
    edtStatusProdutoAssociado.SetParentComponent(Self);
    edtStatusProdutoAssociado.Name := 'edtStatusProdutoAssociado';
    edtStatusProdutoAssociado.Left := 112;
    edtStatusProdutoAssociado.Top := 111;
    edtStatusProdutoAssociado.Width := 121;
    edtStatusProdutoAssociado.Height := 22;
    edtStatusProdutoAssociado.ChildOrder := 89;
    edtStatusProdutoAssociado.Enabled := False;
    edtStatusProdutoAssociado.HeightPercent := 100.000000000000000000;
    edtStatusProdutoAssociado.WidthPercent := 100.000000000000000000;
    btnAssociarProduto.SetParentComponent(Self);
    btnAssociarProduto.Name := 'btnAssociarProduto';
    btnAssociarProduto.Left := 267;
    btnAssociarProduto.Top := 60;
    btnAssociarProduto.Width := 96;
    btnAssociarProduto.Height := 25;
    btnAssociarProduto.Caption := 'Associar Produto';
    btnAssociarProduto.ChildOrder := 16;
    btnAssociarProduto.HeightPercent := 100.000000000000000000;
    btnAssociarProduto.Visible := False;
    btnAssociarProduto.WidthPercent := 100.000000000000000000;
    SetEvent(btnAssociarProduto, Self, 'OnClick', 'btnAssociarProdutoClick');
    btnAlterarImagem.SetParentComponent(Self);
    btnAlterarImagem.Name := 'btnAlterarImagem';
    btnAlterarImagem.Left := 267;
    btnAlterarImagem.Top := 120;
    btnAlterarImagem.Width := 96;
    btnAlterarImagem.Height := 25;
    btnAlterarImagem.Caption := 'Alterar Imagem';
    btnAlterarImagem.ChildOrder := 16;
    btnAlterarImagem.HeightPercent := 100.000000000000000000;
    btnAlterarImagem.Visible := False;
    btnAlterarImagem.WidthPercent := 100.000000000000000000;
    SetEvent(btnAlterarImagem, Self, 'OnClick', 'btnAlterarImagemClick');
    btnRemoverAssociacao.SetParentComponent(Self);
    btnRemoverAssociacao.Name := 'btnRemoverAssociacao';
    btnRemoverAssociacao.Left := 267;
    btnRemoverAssociacao.Top := 26;
    btnRemoverAssociacao.Width := 96;
    btnRemoverAssociacao.Height := 25;
    btnRemoverAssociacao.Caption := 'Remover Associa'#231#227'o';
    btnRemoverAssociacao.ChildOrder := 16;
    btnRemoverAssociacao.HeightPercent := 100.000000000000000000;
    btnRemoverAssociacao.Visible := False;
    btnRemoverAssociacao.WidthPercent := 100.000000000000000000;
    SetEvent(btnRemoverAssociacao, Self, 'OnClick', 'btnRemoverAssociacaoClick');
    btnSolicitarCadastroProduto.SetParentComponent(Self);
    btnSolicitarCadastroProduto.Name := 'btnSolicitarCadastroProduto';
    btnSolicitarCadastroProduto.Left := 267;
    btnSolicitarCadastroProduto.Top := 89;
    btnSolicitarCadastroProduto.Width := 96;
    btnSolicitarCadastroProduto.Height := 25;
    btnSolicitarCadastroProduto.Caption := 'Solicitar cadastro meu produto';
    btnSolicitarCadastroProduto.ChildOrder := 16;
    btnSolicitarCadastroProduto.HeightPercent := 100.000000000000000000;
    btnSolicitarCadastroProduto.WidthPercent := 100.000000000000000000;
    SetEvent(btnSolicitarCadastroProduto, Self, 'OnClick', 'btnSolicitarCadastroProdutoClick');
    pnlModalBuscarProdutos.SetParentComponent(Self);
    pnlModalBuscarProdutos.Name := 'pnlModalBuscarProdutos';
    pnlModalBuscarProdutos.Left := 642;
    pnlModalBuscarProdutos.Top := 3;
    pnlModalBuscarProdutos.Width := 263;
    pnlModalBuscarProdutos.Height := 17;
    pnlModalBuscarProdutos.Caption := 'Espa'#231'o modal buscar produtos';
    pnlModalBuscarProdutos.ChildOrder := 23;
    pnlModalBuscarProdutos.Color := clInfoText;
    pnlModalBuscarProdutos.Font.Charset := DEFAULT_CHARSET;
    pnlModalBuscarProdutos.Font.Color := clWhite;
    pnlModalBuscarProdutos.Font.Height := -11;
    pnlModalBuscarProdutos.Font.Name := 'Tahoma';
    pnlModalBuscarProdutos.Font.Style := [fsBold];
    pnlModalBuscarProdutos.ParentFont := False;
    pnlModalBuscarProdutos.TabOrder := 9;
    pnlModalBuscarProdutos.Visible := False;
    tblProdutos.SetParentComponent(Self);
    tblProdutos.Name := 'tblProdutos';
    tblProdutos.Left := 642;
    tblProdutos.Top := 58;
    tblProdutos.Width := 263;
    tblProdutos.Height := 95;
    tblProdutos.ElementClassName := 'table-responsive';
    tblProdutos.BorderColor := clSilver;
    tblProdutos.ChildOrder := 93;
    tblProdutos.ColHeader := False;
    tblProdutos.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblProdutos, Self, 'OnGetCellChildren', 'tblProdutosGetCellChildren');
    SetEvent(tblProdutos, Self, 'OnGetCellClass', 'tblProdutosGetCellClass');
    tblProdutos.Columns.Clear;
    with tblProdutos.Columns.Add do
    begin
      Title := 'Associar';
    end;
    with tblProdutos.Columns.Add do
    begin
      Title := 'Imagem';
    end;
    with tblProdutos.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'Nome';
    end;
    with tblProdutos.Columns.Add do
    begin
      DataField := 'codigo_barras';
      Title := 'C'#243'd. Barras';
    end;
    with tblProdutos.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    tblProdutos.DataSource := dtsProdutos;
    cbbProdutos.SetParentComponent(Self);
    cbbProdutos.Name := 'cbbProdutos';
    cbbProdutos.Left := 824;
    cbbProdutos.Top := 26;
    cbbProdutos.Width := 81;
    cbbProdutos.Height := 23;
    cbbProdutos.HeightPercent := 100.000000000000000000;
    cbbProdutos.TabOrder := 2;
    cbbProdutos.Text := '10';
    cbbProdutos.WidthPercent := 100.000000000000000000;
    SetEvent(cbbProdutos, Self, 'OnChange', 'cbbProdutosChange');
    cbbProdutos.ItemIndex := 0;
    cbbProdutos.Items.BeginUpdate;
    try
      cbbProdutos.Items.Clear;
      cbbProdutos.Items.Add('10');
      cbbProdutos.Items.Add('25');
      cbbProdutos.Items.Add('50');
      cbbProdutos.Items.Add('100');
    finally
      cbbProdutos.Items.EndUpdate;
    end;
    edtProdutos.SetParentComponent(Self);
    edtProdutos.Name := 'edtProdutos';
    edtProdutos.Left := 642;
    edtProdutos.Top := 25;
    edtProdutos.Width := 121;
    edtProdutos.Height := 21;
    edtProdutos.ChildOrder := 95;
    edtProdutos.HeightPercent := 100.000000000000000000;
    edtProdutos.TabOrder := 3;
    edtProdutos.WidthPercent := 100.000000000000000000;
    SetEvent(edtProdutos, Self, 'OnKeyDown', 'edtProdutosKeyDown');
    wlcProdutoPaginacao.SetParentComponent(Self);
    wlcProdutoPaginacao.Name := 'wlcProdutoPaginacao';
    wlcProdutoPaginacao.Left := 642;
    wlcProdutoPaginacao.Top := 167;
    wlcProdutoPaginacao.Width := 85;
    wlcProdutoPaginacao.Height := 25;
    wlcProdutoPaginacao.HeightPercent := 100.000000000000000000;
    wlcProdutoPaginacao.WidthPercent := 100.000000000000000000;
    wlcProdutoPaginacao.ChildOrder := 97;
    wlcProdutoPaginacao.DefaultItemClassName := 'page-item';
    wlcProdutoPaginacao.DefaultItemLinkClassName := 'page-link';
    wlcProdutoPaginacao.ElementListClassName := 'pagination';
    wlcProdutoPaginacao.Items.Clear;
    with wlcProdutoPaginacao.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with wlcProdutoPaginacao.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with wlcProdutoPaginacao.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    wlcProdutoPaginacao.Style := lsPagination;
    pnlModalAlterarImagem.SetParentComponent(Self);
    pnlModalAlterarImagem.Name := 'pnlModalAlterarImagem';
    pnlModalAlterarImagem.Left := 369;
    pnlModalAlterarImagem.Top := 3;
    pnlModalAlterarImagem.Width := 263;
    pnlModalAlterarImagem.Height := 17;
    pnlModalAlterarImagem.Caption := 'Espa'#231'o modal alterar imagem';
    pnlModalAlterarImagem.ChildOrder := 23;
    pnlModalAlterarImagem.Color := clInfoText;
    pnlModalAlterarImagem.Font.Charset := DEFAULT_CHARSET;
    pnlModalAlterarImagem.Font.Color := clWhite;
    pnlModalAlterarImagem.Font.Height := -11;
    pnlModalAlterarImagem.Font.Name := 'Tahoma';
    pnlModalAlterarImagem.Font.Style := [fsBold];
    pnlModalAlterarImagem.ParentFont := False;
    pnlModalAlterarImagem.TabOrder := 14;
    pnlModalAlterarImagem.Visible := False;
    wfpImagem.SetParentComponent(Self);
    wfpImagem.Name := 'wfpImagem';
    wfpImagem.Left := 369;
    wfpImagem.Top := 73;
    wfpImagem.Width := 78;
    wfpImagem.Height := 19;
    wfpImagem.Accept := '.png,.jpg,.jpeg,.webp';
    wfpImagem.ChildOrder := 1;
    SetEvent(wfpImagem, Self, 'OnChange', 'wfpImagemChange');
    SetEvent(wfpImagem, Self, 'OnGetFileAsBase64', 'wfpImagemGetFileAsBase64');
    btnSalvarImagem.SetParentComponent(Self);
    btnSalvarImagem.Name := 'btnSalvarImagem';
    btnSalvarImagem.Left := 536;
    btnSalvarImagem.Top := 26;
    btnSalvarImagem.Width := 96;
    btnSalvarImagem.Height := 25;
    btnSalvarImagem.Caption := 'Salvar';
    btnSalvarImagem.ChildOrder := 16;
    btnSalvarImagem.HeightPercent := 100.000000000000000000;
    btnSalvarImagem.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarImagem, Self, 'OnClick', 'btnSalvarImagemClick');
    divRemoverImagem.SetParentComponent(Self);
    divRemoverImagem.Name := 'divRemoverImagem';
    divRemoverImagem.Left := 369;
    divRemoverImagem.Top := 98;
    divRemoverImagem.Width := 100;
    divRemoverImagem.Height := 19;
    divRemoverImagem.ChildOrder := 21;
    divRemoverImagem.Role := '';
    SetEvent(divRemoverImagem, Self, 'OnClick', 'divRemoverImagemClick');
    btnPesquisarFsProduto.SetParentComponent(Self);
    btnPesquisarFsProduto.Name := 'btnPesquisarFsProduto';
    btnPesquisarFsProduto.Left := 642;
    btnPesquisarFsProduto.Top := 198;
    btnPesquisarFsProduto.Width := 96;
    btnPesquisarFsProduto.Height := 25;
    btnPesquisarFsProduto.Caption := 'Pesquisar';
    btnPesquisarFsProduto.ChildOrder := 16;
    btnPesquisarFsProduto.HeightPercent := 100.000000000000000000;
    btnPesquisarFsProduto.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarFsProduto, Self, 'OnClick', 'btnPesquisarFsProdutoClick');
    cdsProdutos.SetParentComponent(Self);
    cdsProdutos.Name := 'cdsProdutos';
    cdsProdutos.EntitySetName := 'Fs_Prod_Produtos';
    cdsProdutos.Connection := DMConnection.ApiConnection;
    cdsProdutos.Left := 400;
    cdsProdutos.Top := 164;
    cdsProdutosid.SetParentComponent(cdsProdutos);
    cdsProdutosid.Name := 'cdsProdutosid';
    cdsProdutosid.FieldName := 'id';
    cdsProdutosid.Required := True;
    SetEvent(cdsProdutosid, Self, 'OnGetText', 'cdsProdutosidGetText');
    cdsProdutosnome.SetParentComponent(cdsProdutos);
    cdsProdutosnome.Name := 'cdsProdutosnome';
    cdsProdutosnome.FieldName := 'nome';
    cdsProdutosnome.Required := True;
    cdsProdutosnome.Size := 255;
    cdsProdutoscodigo_barras.SetParentComponent(cdsProdutos);
    cdsProdutoscodigo_barras.Name := 'cdsProdutoscodigo_barras';
    cdsProdutoscodigo_barras.FieldName := 'codigo_barras';
    cdsProdutoscodigo_barras.Required := True;
    cdsProdutoscodigo_barras.Size := 255;
    cdsProdutosimagem.SetParentComponent(cdsProdutos);
    cdsProdutosimagem.Name := 'cdsProdutosimagem';
    cdsProdutosimagem.FieldName := 'imagem';
    cdsProdutosimagem.Size := 255;
    dtsProdutos.SetParentComponent(Self);
    dtsProdutos.Name := 'dtsProdutos';
    dtsProdutos.DataSet := cdsProdutos;
    dtsProdutos.Left := 480;
    dtsProdutos.Top := 172;
    XDataWebClientAssociacao.SetParentComponent(Self);
    XDataWebClientAssociacao.Name := 'XDataWebClientAssociacao';
    XDataWebClientAssociacao.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientAssociacao, Self, 'OnError', 'XDataWebClientAssociacaoError');
    XDataWebClientAssociacao.Left := 168;
    XDataWebClientAssociacao.Top := 160;
  finally
    lblCodigoProdutoAssociado.AfterLoadDFMValues;
    lblNomeProdutoAssociado.AfterLoadDFMValues;
    lblCodBarrasProdutoAssociado.AfterLoadDFMValues;
    lblStatusProdutoAssociado.AfterLoadDFMValues;
    imgProduto.AfterLoadDFMValues;
    lblProdutosPaginacao.AfterLoadDFMValues;
    imgImagemSelecionada.AfterLoadDFMValues;
    pnlProdutoAssociado.AfterLoadDFMValues;
    edtCodigoProdutoAssociado.AfterLoadDFMValues;
    edtNomeProdutoAssociado.AfterLoadDFMValues;
    edtCodBarrasProdutoAssociado.AfterLoadDFMValues;
    edtStatusProdutoAssociado.AfterLoadDFMValues;
    btnAssociarProduto.AfterLoadDFMValues;
    btnAlterarImagem.AfterLoadDFMValues;
    btnRemoverAssociacao.AfterLoadDFMValues;
    btnSolicitarCadastroProduto.AfterLoadDFMValues;
    pnlModalBuscarProdutos.AfterLoadDFMValues;
    tblProdutos.AfterLoadDFMValues;
    cbbProdutos.AfterLoadDFMValues;
    edtProdutos.AfterLoadDFMValues;
    wlcProdutoPaginacao.AfterLoadDFMValues;
    pnlModalAlterarImagem.AfterLoadDFMValues;
    wfpImagem.AfterLoadDFMValues;
    btnSalvarImagem.AfterLoadDFMValues;
    divRemoverImagem.AfterLoadDFMValues;
    btnPesquisarFsProduto.AfterLoadDFMValues;
    cdsProdutos.AfterLoadDFMValues;
    cdsProdutosid.AfterLoadDFMValues;
    cdsProdutosnome.AfterLoadDFMValues;
    cdsProdutoscodigo_barras.AfterLoadDFMValues;
    cdsProdutosimagem.AfterLoadDFMValues;
    dtsProdutos.AfterLoadDFMValues;
    XDataWebClientAssociacao.AfterLoadDFMValues;
  end;
end;

end.